import React from "react";
import { getStates } from "../../services/helpers";
import MonthYearPicker from "../component-tools/MonthYearPicker";

export interface Address {
  address: string;
  zipCode: string;
  city: string;
  state: string;
  country: string;
  county: string;
  fromDate: Date;
  toDate: Date;
}

interface AddressFormProps {
  address: Address;
  validationErrors: { [key: string]: string };
  onInputChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    field: string,
    index: number,
    type: string
  ) => void;
  onDelete: () => void;
  index: number;
  type: string;
}

const AddressForm: React.FC<AddressFormProps> = ({
  address,
  validationErrors,
  onInputChange,
  onDelete,
  index,
  type,
}) => {
  const states = getStates();

  return (
    <div className="data-container">
      <div className="text-sub-sub-header" style={{ flex: "0 0 100%" }}>
        {type} Address #{index + 1}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 40%" }}>
        <label className="field-label">Address:</label>
        <input
          className={`form-control ${
            validationErrors[`address-${type}-${index}`] ? "is-invalid" : ""
          }`}
          type="text"
          value={address.address || ""}
          onChange={(e) => onInputChange(e, "address", index, type)}
        />
        {validationErrors[`address-${type}-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`address-${type}-${index}`]}
          </div>
        )}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 30%" }}>
        <label className="field-label">City:</label>
        <input
          className={`form-control ${
            validationErrors[`city-${type}-${index}`] ? "is-invalid" : ""
          }`}
          type="text"
          value={address.city || ""}
          onChange={(e) => onInputChange(e, "city", index, type)}
        />
        {validationErrors[`city-${type}-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`city-${type}-${index}`]}
          </div>
        )}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 20%" }}>
        <label className="field-label">State:</label>
        <select
          className={`form-select ${
            validationErrors[`state-${type}-${index}`] ? "is-invalid" : ""
          }`}
          value={address.state || ""}
          onChange={(e) => onInputChange(e, "state", index, type)}
        >
          <option value="">Select State</option>
          {states.map((state) => (
            <option key={state.abbreviation} value={state.abbreviation}>
              {state.name} ({state.abbreviation})
            </option>
          ))}
        </select>
        {validationErrors[`state-${type}-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`state-${type}-${index}`]}
          </div>
        )}
      </div>

      {address.state === "INT" && (
        <div className="field-stacked" style={{ flex: "0 0 20%" }}>
          <label className="field-label">Country:</label>
          <div className="field-input">
            <input
              className="form-control"
              type="text"
              value={address.country ? address.country : ""}
              onChange={(e) => onInputChange(e, "country", index, type)}
            />
          </div>
        </div>
      )}

      <div className="field-stacked" style={{ flex: "0 0 20%" }}>
        <label className="field-label">Zip Code:</label>
        <input
          className={`form-control ${
            validationErrors[`zipCode-${type}-${index}`] ? "is-invalid" : ""
          }`}
          type="text"
          value={address.zipCode || ""}
          onChange={(e) => onInputChange(e, "zipCode", index, type)}
        />
        {validationErrors[`zipCode-${type}-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`zipCode-${type}-${index}`]}
          </div>
        )}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 30%" }}>
        <label className="field-label">County:</label>
        <input
          className={`form-control ${
            validationErrors[`county-${type}-${index}`] ? "is-invalid" : ""
          }`}
          type="text"
          value={address.county || ""}
          onChange={(e) => onInputChange(e, "county", index, type)}
        />
        {validationErrors[`county-${type}-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`county-${type}-${index}`]}
          </div>
        )}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 20%" }}>
        <label className="field-label">From:</label>
        <MonthYearPicker
          value={address.fromDate}
          onChange={(newDate) =>
            onInputChange(
              { target: { value: newDate } } as any,
              "fromDate",
              index,
              type
            )
          }
        />
        {validationErrors[`fromDate-${type}-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`fromDate-${type}-${index}`]}
          </div>
        )}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 20%" }}>
        <label className="field-label">To:</label>
        <MonthYearPicker
          value={address.toDate}
          onChange={(newDate) =>
            onInputChange(
              { target: { value: newDate } } as any,
              "toDate",
              index,
              type
            )
          }
        />
        {validationErrors[`toDate-${type}-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`toDate-${type}-${index}`]}
          </div>
        )}
      </div>

      <div style={{ flex: "0 0 100%" }}>
        <button className="oxbtn btn-red" onClick={onDelete}>
          Delete
        </button>
      </div>
    </div>
  );
};

export default AddressForm;
